import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useTranslation } from "react-i18next";
import { Pagination } from "ui";

import {
  AuditLogsTable,
  AuditLogsTableFilter,
  InfoBanner
} from "../../components";
import { useAuditLogsList } from "../../hooks";

import styles from "./AuditLog.module.scss";

const AuditLog = () => {
  const { t } = useTranslation();

  const {
    value: isFilterOpen,
    toggle: toggleFilter,
    setFalse: closeFilter
  } = useBoolean(false);

  const {
    auditLogs,
    totalItems,
    sorting,
    setSorting,
    page,
    setPage,
    isLoading
  } = useAuditLogsList();

  return (
    <ContentLayout title={t("Activity Log")}>
      <BoxShadowLayout className={styles.auditLog}>
        <InfoBanner>
          {t(
            "Only admin changes are recorded — reads and failed attempts are not logged."
          )}
        </InfoBanner>

        <div className={styles.auditLog__header}>
          <span className={styles.auditLog__count}>
            {t("Total")}: {totalItems}
          </span>

          <AuditLogsTableFilter
            isLoading={isLoading}
            isOpen={isFilterOpen}
            onClose={closeFilter}
            onToggle={toggleFilter}
          />
        </div>

        <AuditLogsTable
          auditLogs={auditLogs ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default AuditLog;
